import StringConverter from './StringConverter'

export { default as StringConverter } from './StringConverter'
export { default as NumberConverter, NO_CURRENCY_SYMBOL } from './NumberConverter'

/** Parses a user-typed numeric string. Locale-aware; see {@link StringConverter}. */
export const fromNumberString = (value: string) => new StringConverter(value)
